import { NgModule } from '@angular/core';
import { MerchantTypePipe } from './merchant-type.pipe';
import { PaymentTypePipe } from './payment-type.pipe';
import { FromEnumPipe } from './from-enum.pipe';
import { ReplacePipe } from './replace.pipe';
import { DisplayValuePipe } from './display-value.pipe';
import { HasRolePipe } from './has-role.pipe';
import { PaymentMethodPipe } from './payment-method.pipe';
import { OrderStatusPipe } from './order-status.pipe';
import { CardStatusPipe } from './card-status.pipe';
import { AgentCommissionSourcePipe } from './agent-commission-source.pipe';
import { AgentCommissionStatusPipe } from './agent-commission-status.pipe';
import { ListFilterPipe } from './list-filter.pipe';
import { ProductListFilterPipe } from './product-list-filter.pipe';
import { UploadStatusPipe } from './upload-status.pipe';
import { BankTransactionStatusPipe } from './bank-transaction-status.pipe';
import { UserApprovalStatusPipe } from './user-approval-status.pipe';
import { CommissionUploadStatusPipe } from './commission-upload-status.pipe';
import { SapPaymentTypePipe } from './sap-payment-type.pipe';
import { AgentRelationshipPipe } from './agent-relationship.pipe';
import { SapMerchantTypePipe } from './sap-merchant-type.pipe';
import { CronjobsPipe } from './cronjobs.pipe';

const pipeModules = [
  MerchantTypePipe,
  PaymentTypePipe,
  FromEnumPipe,
  ReplacePipe,
  DisplayValuePipe,
  HasRolePipe,
  PaymentMethodPipe,
  OrderStatusPipe,
  CardStatusPipe,
  AgentCommissionSourcePipe,
  AgentCommissionStatusPipe,
  ListFilterPipe,
  ProductListFilterPipe,
  UploadStatusPipe,
  BankTransactionStatusPipe,
  UserApprovalStatusPipe,
  CommissionUploadStatusPipe,
  SapPaymentTypePipe,
  AgentRelationshipPipe,
  SapMerchantTypePipe,
  CronjobsPipe
];
@NgModule({
  declarations: pipeModules,
  providers: pipeModules,
  exports: pipeModules
})
export class ApplicationPipesModule {};
